// src/index.tsx
import { useEffect, useState } from "react";
import {
  Select as ChakraSelect
} from "chakra-react-select";
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  InputRightElement,
  InputGroup
} from "@chakra-ui/react";
import { theme } from "@airhelp/chakra-theme";
import { Info } from "@airhelp/icons";
import { defaultErrorIconColor, defaultHoverErrorIconColor, ErrorIconColor } from "@airhelp/input";
import { useMobileDetect } from "@airhelp/use-mobile-detect";
import { jsx, jsxs } from "react/jsx-runtime";
var Select = ({
  label,
  placeholder,
  caption,
  errorMessage,
  colorScheme = "error",
  isDisabled,
  isInvalid,
  dataTestId,
  formControlStyles,
  handleChange,
  isSearchable = false,
  ...props
}) => {
  const [errorIconColor, setErrorIconColor] = useState(
    colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger
  );
  const [isSelectFocused, setIsSelectFocused] = useState(false);
  const isMobile = useMobileDetect();
  const hoveredErrorIconColor = () => isMobile ? defaultErrorIconColor(colorScheme) : defaultHoverErrorIconColor(colorScheme);
  useEffect(() => {
    setErrorIconColor(defaultErrorIconColor(colorScheme));
  }, [colorScheme]);
  const onFocus = () => {
    setErrorIconColor("transparent");
    setIsSelectFocused(true);
  };
  const onBlur = () => {
    setErrorIconColor(defaultErrorIconColor(colorScheme));
    setIsSelectFocused(false);
  };
  const onMouseOver = () => {
    if (!isSelectFocused) {
      setErrorIconColor(hoveredErrorIconColor());
    }
  };
  const onMouseOut = () => {
    if (!isSelectFocused) {
      setErrorIconColor(defaultErrorIconColor(colorScheme));
    }
  };
  return /* @__PURE__ */ jsxs(FormControl, {
    ...formControlStyles,
    alignItems: "start",
    isInvalid,
    children: [
      label && /* @__PURE__ */ jsx(FormLabel, {
        fontWeight: "bold",
        children: label
      }),
      /* @__PURE__ */ jsx(InputGroup, {
        onFocus,
        onBlur,
        onMouseOver,
        onMouseOut,
        "data-testid": dataTestId,
        isolation: "unset",
        children: /* @__PURE__ */ jsx(ChakraSelect, {
          ...props,
          placeholder,
          chakraStyles: theme.components.getSelectStyles(),
          isSearchable,
          isDisabled,
          colorScheme,
          onChange: handleChange
        })
      }),
      /* @__PURE__ */ jsx(FormErrorMessage, {
        colorScheme,
        children: errorMessage
      }),
      isInvalid && /* @__PURE__ */ jsx(InputGroup, {
        children: /* @__PURE__ */ jsx(InputRightElement, {
          right: 6,
          top: "unset",
          bottom: "27px",
          pointerEvents: "none",
          children: /* @__PURE__ */ jsx(Info, {
            boxSize: 4,
            pointerEvents: "none",
            color: errorIconColor
          })
        })
      }),
      caption && !isInvalid && /* @__PURE__ */ jsx(FormHelperText, {
        children: caption
      })
    ]
  });
};
export {
  Select
};
